// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-step__title{font-size:13px;line-height:30px}.sccd{position:absolute;right:15px;z-index:1000}", ""]);
// Exports
module.exports = exports;
